import React, { useState } from 'react'
import Modal from "./Modal"
import { useLocation, useHistory } from 'react-router-dom';
import style from "../style/components/forgot.module.css"

import axios from "axios"


const ForgotPassRewrite = () => {
  const [newPass, setNewPass] = useState("")
  const [newPassOneMore, setNewPassOneMore] = useState("")

  const location = useLocation();
  const token = location.pathname.split("/")[2]
  const history = useHistory();

  const handleClickNewPass = async (e) => {
    e.preventDefault()
    try {
      if (newPass !== newPassOneMore) {
        alert("Пароли не совпадают")
        return
      }
      const res = await axios.post("https://rishat-tour.ru/api/auth/reset-password/" + token, {
        newPassword: newPass
      })
      history.push("/")
      console.log(res.data)
    } catch (e) {
      console.log(e)
    }
  }
  return (
    <Modal onClose={() => history.push("/")}>
      <form className={style.wrap} onSubmit={handleClickNewPass}>
        <h2>Введите и подтвердите новый пароль</h2>
        <input placeholder="Новый пароль" onChange={(e) => setNewPass(e.target.value)} />
        <input placeholder="Потвердите пароль" onChange={(e) => setNewPassOneMore(e.target.value)} />
        <button>Запомнить пароль</button>
      </form>
    </Modal>
  )
}

export default ForgotPassRewrite